/**
 * Type of timeshipping
 *
 * @export
 * @enum {number}
 */
export enum ShippingType {
    Date, OneDay, Today
}
